import { get } from 'lodash';
import { ANTRAGS_FORMULAREN } from '../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc, groupKostenByPosition } from '../../../../../utils/helper';
import { TreeStructureAntragEbusse } from './ebusse/TreeStructureAntragEbusse';
import { TreeStructureAntragEmob } from './emob/TreeStructureAntragEmob';
import { TreeStructureAntragEPZ } from './epz/TreeStructureAntragEPZ';
import { TreeStructureAntragKreativwirtschaft } from './kreativwirtschaft/TreeStructureAntragKreativwirtschaft';
import { TreeStructureAntragLoewe } from './loewe/TreeStructureAntragLoewe';
import { TreeStructureAntragLogMob } from './logmob/TreeStructureAntragLogMob';
import { TreeStructureAntragMessefoerderung } from './messefoerderung/TreeStructureAntragMesseFoerderung';
import { TreeStructureAntragMobilitaetsplaene } from './mobilitaetsplaene/TreeStructureAntragMobilitaetsplan';
import { TreeStructureAntragStartupProjekte } from './startupprojekte/TreeStructureAntragStartupProjekte';
import { TreeStructureAntragStipendium } from './stipendium/TreeStructureAntragStipendium';

// import schemas
import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureFoerderAntrag = (
	application: any,
	kostenKategories: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
	readOnly: boolean,
) => {
	let treeNodes: TreeNodeType[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);
	const antragFormular = get(application, P.Allgemein_Antragsformular.path, '');

	switch (antragFormular) {
		case ANTRAGS_FORMULAREN.EmobFundE:
		case ANTRAGS_FORMULAREN.EmobLis:
		case ANTRAGS_FORMULAREN.EmobInvest:
			treeNodes = TreeStructureAntragEmob(
				application,
				kostenKategories,
				readOnly,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Messefoerderung:
			treeNodes = TreeStructureAntragMessefoerderung(
				application,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.StartUpProjekte:
			treeNodes = TreeStructureAntragStartupProjekte(
				application,
				readOnly,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Kreativwirtschaft:
			treeNodes = TreeStructureAntragKreativwirtschaft(
				application,
				readOnly,
				kostenKategories,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Mobilitaetsplaene:
			treeNodes = TreeStructureAntragMobilitaetsplaene(
				application,
				kostenKategoriesGroup,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
			treeNodes = TreeStructureAntragEPZ(
				application,
				kostenKategoriesGroup,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Loewe:
			treeNodes = TreeStructureAntragLoewe(
				application,
				kostenKategoriesGroup,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Elektrobusse:
			treeNodes = TreeStructureAntragEbusse(
				application,
				readOnly,
				kostenKategories,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.LogistikUndMobilitaet:
			treeNodes = TreeStructureAntragLogMob(
				application,
				readOnly,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.StartUpStipendium:
			treeNodes = TreeStructureAntragStipendium(
				application,
				readOnly,
				kostenKategories,
				kostenKategoriesGroup,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		default:
			treeNodes = [];
			break;
	}

	return assignIdsToStruc(treeNodes);
};
